export interface DeductionTypeProps {
    id: number;
    parentId: number;
    deductionName: string;
    deductionTypeKey: string;
}

export class DeductionType {
    private readonly _id: number;
    private readonly _parentId: number;
    private readonly _deductionName: string;
    private readonly _deductionTypeKey: string;
    
    constructor(props: DeductionTypeProps) {
        this._id = props.id;
        this._parentId = props.parentId;
        this._deductionName = props.deductionName;
        this._deductionTypeKey = props.deductionTypeKey;
    }

    public get id(): number {
        return this._id;
    }

    public get parentId(): number {
        return this._parentId;
    }

    public get deductionName(): string {
        return this._deductionName;
    }

    public get deductionTypeKey(): string {
        return this._deductionTypeKey;
    }
}
